import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { PageLayoutComponent } from '../../../components/shared/page-layout/page-layout.component';

@Component({
  selector: 'app-assurance-auto-professionnelle',
  standalone: true,
  imports: [CommonModule, PageLayoutComponent],
  templateUrl: './assurance-auto-professionnelle.component.html',
  styleUrls: ['./assurance-auto-professionnelle.component.scss']
})
export class AssuranceAutoProfessionnelleComponent {
  title = 'Assurance Auto Professionnelle';
  subtitle = '';
  heroImage = 'assets/static_pages_images/auto-peso.jpg';
  
  breadcrumbs = [
    { label: 'Entreprises', link: undefined },
    { label: 'Assurance Auto Professionnelle', link: undefined }
  ];

  prevPage = { 
    title: 'Assurance des Biens pour Professionnels et Entreprises',
    link: '/assurance-biens-professionnels'
  };

  nextPage = { 
    title: 'Assurance Moto Professionnelle',
    link: '/assurance-moto-professionnelle'
  };

  // Partners logos for carousel
  partners = [
    { name: 'Generali', logo: 'assets/logos/GENERALI.PNG' },
    { name: 'QIDFIL', logo: 'assets/logos/qidfil.png' },
    { name: 'Progeas', logo: 'assets/logos/progeas.png' },
    { name: 'SwissLife', logo: 'assets/logos/SWISSLIFE.PNG' },
    { name: 'Zephir', logo: 'assets/logos/zephir.png' },
    { name: 'Novelia', logo: 'assets/logos/novelia.png' },
    { name: 'Solly Azar', logo: 'assets/logos/SOLLYAZAR.PNG' },
    { name: 'FMA', logo: 'assets/logos/fma.png' },
    { name: 'Xenassur', logo: 'assets/logos/xenassur.png' },
  ];

  constructor(private router: Router) {}
}
